export default __webpack_public_path__ + "static/media/Morph Panther Pict Berserker.18f194d5.jpg";